/**
 * Veloura Track Order — lightweight helper only.
 * Widget is mounted declaratively in Liquid + script starts in <head>.
 * This file must NOT remount (remounts restart Track123 and make it slower).
 */
(function () {
  'use strict';

  var BASE = 'https://shp.track123.com';
  var VERSION_URL = BASE + '/tracking-page/version.json';
  var cssInterceptInstalled = false;
  var middleScreenPreloaded = false;

  try {
    if (!window.track123BaseUrl) window.track123BaseUrl = BASE;
  } catch (e) {}

  function rootEl() {
    return document.getElementById('vel-track123-widget');
  }

  function fixMiddleScreenCssHref(href) {
    if (!href || href.indexOf('middleScreen-tradition') === -1) return null;
    if (/\/build\/\d+\/middleScreen-tradition\.min\.css/.test(href)) return null;
    var version = window.track123Version || '';
    var m = String(href).match(/[?&]v=([^&]+)/);
    if (m) version = m[1];
    if (!version) {
      m = String(href).match(/\/build\/(\d+)\//);
      if (m) version = m[1];
    }
    return version ? BASE + '/tracking-page/build/' + version + '/middleScreen-tradition.min.css' : null;
  }

  function patchStylesheetLinks() {
    var links = document.querySelectorAll('link[rel="stylesheet"]');
    for (var i = 0; i < links.length; i++) {
      var link = links[i];
      var href = link.getAttribute('href') || link.href || '';
      var fixed = fixMiddleScreenCssHref(href);
      if (fixed && href !== fixed) link.href = fixed;
    }
  }

  function preloadMiddleScreenCss() {
    var version = window.track123Version;
    if (!version || middleScreenPreloaded) return;
    if (document.querySelector('link[data-vel-track123-midscreen]')) {
      middleScreenPreloaded = true;
      return;
    }
    var link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = BASE + '/tracking-page/build/' + version + '/middleScreen-tradition.min.css';
    link.setAttribute('data-vel-track123-midscreen', '1');
    document.head.appendChild(link);
    middleScreenPreloaded = true;
  }

  function installCssIntercept() {
    if (cssInterceptInstalled) return;
    cssInterceptInstalled = true;
    try {
      var desc = Object.getOwnPropertyDescriptor(HTMLLinkElement.prototype, 'href');
      if (desc && desc.set) {
        var originalSet = desc.set;
        Object.defineProperty(HTMLLinkElement.prototype, 'href', {
          configurable: true,
          enumerable: desc.enumerable,
          get: desc.get,
          set: function (value) {
            var fixed = fixMiddleScreenCssHref(String(value || ''));
            originalSet.call(this, fixed || value);
          }
        });
      }
      var originalSetAttribute = HTMLLinkElement.prototype.setAttribute;
      HTMLLinkElement.prototype.setAttribute = function (name, value) {
        if (String(name).toLowerCase() === 'href') {
          var fixed = fixMiddleScreenCssHref(String(value || ''));
          if (fixed) value = fixed;
        }
        return originalSetAttribute.call(this, name, value);
      };
    } catch (e) {}
  }

  function ensureVersion() {
    if (window.track123Version) {
      preloadMiddleScreenCss();
      return;
    }
    try {
      fetch(VERSION_URL, { credentials: 'omit', mode: 'cors', cache: 'force-cache' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (data) {
          if (data && data.version) {
            try { window.track123Version = String(data.version); } catch (e) {}
          }
          preloadMiddleScreenCss();
          patchStylesheetLinks();
        })
        .catch(function () {});
    } catch (e) {}
  }

  function clearStatus(root) {
    if (!root) return;
    var existing = root.querySelector('[data-vel-track-status]');
    if (existing) existing.remove();
  }

  function setError(root, message) {
    if (!root) return;
    clearStatus(root);
    var el = document.createElement('p');
    el.setAttribute('data-vel-track-status', 'error');
    el.setAttribute('role', 'alert');
    el.className = 'vel-track-status vel-track-status--error';
    el.textContent = message;
    root.insertBefore(el, root.firstChild);
  }

  function isReady(root) {
    if (!root) return false;
    var widget = root.querySelector('track123-tracking-widget');
    if (!widget) return false;
    if (widget.querySelector('.track123_loading')) return false;
    if (widget.querySelector('[style*="e74c3c"]')) return true; /* widget error box */
    return !!(
      widget.querySelector('input') ||
      widget.querySelector('#track123_submit_button') ||
      widget.querySelector('.track123_form_input') ||
      widget.querySelector('.track123_form_wrapper') ||
      widget.querySelector('.track123_track_wrapper')
    );
  }

  function ensureWidget(root) {
    if (!root) return;
    if (root.querySelector('track123-tracking-widget')) return;
    if (!(window.customElements && customElements.get('track123-tracking-widget'))) return;
    var el = document.createElement('track123-tracking-widget');
    var domain = root.getAttribute('data-shopify-domain') || '';
    var locale = root.getAttribute('data-locale') || 'en';
    if (domain) el.setAttribute('shopifyDomain', domain);
    if (locale) el.setAttribute('locale', locale);
    root.insertBefore(el, root.firstChild);
  }

  function watchReady(root) {
    var started = Date.now();
    var timer = setInterval(function () {
      patchStylesheetLinks();
      preloadMiddleScreenCss();
      ensureWidget(root);

      if (isReady(root)) {
        clearInterval(timer);
        clearStatus(root);
        return;
      }

      if (Date.now() - started < 16000) return;
      clearInterval(timer);
      if (!isReady(root)) {
        setError(
          root,
          'Tracking is taking longer than expected. Refresh, or contact support with your order number.'
        );
      }
    }, 200);
  }

  function start() {
    var root = rootEl();
    if (!root) return;
    installCssIntercept();
    ensureVersion();
    ensureWidget(root);
    watchReady(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
